import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-config-loader flex-column justify-content-center align-items-center d-flex" }
const _hoisted_2 = { class: "text-muted loading-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BImg = _resolveComponent("BImg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BImg, {
      src: "/loading.gif",
      fluid: "",
      alt: "Responsive image",
      width: "400",
      height: "300"
    }),
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.loadingMessage), 1)
  ]))
}